<template>
  <div class="row ml-2 mb-5" v-if="form.data.value_type">
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Shippping rates</h4>
      <base-checkbox class="mb-2" :value="true" v-model="form.data._prerequisite_shipping_price_range">
        Exclude shipping rates over a certain amount (Partial subsidy)
        <tooltip :message="'For Lazada, seller will only subsidize the amount set.'"></tooltip>
        <a-input v-if="form.data._prerequisite_shipping_price_range" v-model="form.data.prerequisite_shipping_price_range.less_than_or_equal_to" input-classes="form-control" style="margin-top: 5px;" placeholder="Maximum amount" required :disabled="viewOnly" />
      </base-checkbox>
    </div>
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Minimum requirements</h4>
      <base-radio class="mb-2" name="none" value="none" v-model="form.data._prerequisite_type">
        None
      </base-radio>
      <base-radio class="mb-2" name="subtotal" value="subtotal" v-model="form.data._prerequisite_type">
        Minimum purchase amount (₱)
        <a-input v-if="form.data._prerequisite_type === 'subtotal'" v-model="form.data.prerequisite_subtotal_range.greater_than_or_equal_to" input-classes="form-control" style="margin-top: 5px;" placeholder="Subtotal amount" required :disabled="viewOnly" />
      </base-radio>
      <base-radio class="mb-2" name="quantity" value="quantity" v-model="form.data._prerequisite_type">
        Minimum quantity of items
        <a-input v-if="form.data._prerequisite_type === 'quantity'" v-model="form.data.prerequisite_quantity_range.greater_than_or_equal_to" input-classes="form-control" style="margin-top: 5px;" placeholder="No. of items" required :disabled="viewOnly" />
        <br><small class="text-muted">Applies only to selected products</small>
      </base-radio>
    </div>
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">
        Usage limits
        <tooltip :message="'Only applies to Shopify & BXI Online Store'"></tooltip>
      </h4>
      <base-checkbox class="mb-2" :value="true" v-model="form.data._usage_limit">
        Limit number of times this discount can be used in total
        <a-input v-if="form.data._usage_limit" v-model="form.data.usage_limit" input-classes="form-control" style="margin-top: 5px;" placeholder="Usage limit" required :disabled="viewOnly" />
      </base-checkbox>
      <base-checkbox class="mb-2" :value="true" v-model="form.data.once_per_customer">
        Limit to one use per customer
      </base-checkbox>
    </div>
    <div class="col-md-12 pt-4" v-if="storeTypes['lazada']">
      <h4 class="card-title mb-2">
        Lazada promotion details
        <tooltip :message="'Only applies to Lazada'"></tooltip>
      </h4>
      <label class="mb-0">Delivery Option</label>
      <a-select :options="delivery_options" style="margin-top: 5px; margin-bottom: 0px; width: 100%" v-model="form.data.delivery_option"></a-select>
      <small>Choice of courier option for the customer</small>
      <br class="mb-4">
      <label class="mb-0">Budget Type</label>
      <base-radio class="my-2" name="UNLIMITED_BUDGET" value="UNLIMITED_BUDGET" v-model="form.data.budget_type">
        Unlimited Budget
        <br><small>No limit on this promotion's subsidy budget</small>
      </base-radio>
      <base-radio class="mb-2" name="LIMITED_BUDGET" value="LIMITED_BUDGET" v-model="form.data.budget_type">
        Limited Budget
        <a-input v-if="form.data.budget_type === 'LIMITED_BUDGET'" v-model="form.data.budget_value" input-classes="form-control" style="margin-top: 5px;" placeholder="Total subsidy budget" required :disabled="viewOnly" />
        <br><small>Will use the given amount as the maximum budget for this promotion</small>
      </base-radio>
      <br class="mb-2">
      <label class="mb-0">Applies to</label>
      <base-radio class="my-2" name="ENTIRE_SHOP" value="ENTIRE_SHOP" v-model="form.data.apply">
        Entire Store
        <br><small>Discount is applicable to all products of the store</small>
      </base-radio>
      <base-radio class="mb-2 custom-control-label-100" name="SPECIFIC_PRODUCTS" value="SPECIFIC_PRODUCTS" v-model="form.data.apply">
        Specific Products
        <br><small>Discount is applicable to the selected products</small>
        <product-search-tab
          v-if="form.data.apply === 'SPECIFIC_PRODUCTS'"
          :form="form"
          :products="form.data.entitled_product_ids"
          :viewOnly="viewOnly"
          :sales_channel_stores="form.sales_channel_stores"
        ></product-search-tab>
      </base-radio>
    </div>
    <div class="d-none">{{validationErrors}}</div>
  </div>
  <div v-else></div>
</template>
<script>
  import ProductSearchTab from './ProductSearchTab'
  import Tooltip from './Tooltip'

  export default {
    props: {
      form: Object,
      promotion: Object,
      viewOnly: Boolean,
      storeTypes: Object
    },
    components: {
      ProductSearchTab,
      Tooltip
    },
    name: "free-shipping",
    data() {
      return {
        delivery_options: [
          {label: 'Standard', value: 'STANDARD', disabled: false }
        ]
      }
    },
    methods: {
      validatePromotion: function(){
        let errors = []
        let data = this.form.data
        this.form.data.validationErrors = []

        if(data._prerequisite_shipping_price_range){
          data.prerequisite_shipping_price_range.less_than_or_equal_to = data.prerequisite_shipping_price_range.less_than_or_equal_to ? parseFloat(data.prerequisite_shipping_price_range.less_than_or_equal_to) : 0
          if(data.prerequisite_shipping_price_range.less_than_or_equal_to <= 0)
            errors.push('Maximum amount value must be greater than 0')
        }
        else
          data.prerequisite_shipping_price_range.less_than_or_equal_to = null
        if(data._prerequisite_type === 'subtotal'){
          data.prerequisite_subtotal_range.greater_than_or_equal_to = data.prerequisite_subtotal_range.greater_than_or_equal_to ? parseFloat(data.prerequisite_subtotal_range.greater_than_or_equal_to) : 0
          if(data.prerequisite_subtotal_range.greater_than_or_equal_to <= 0)
            errors.push('Minimum purchase amount must be greater than 0')
        }
        if(data._prerequisite_type === 'quantity'){
          data.prerequisite_quantity_range.greater_than_or_equal_to = data.prerequisite_quantity_range.greater_than_or_equal_to ? parseInt(data.prerequisite_quantity_range.greater_than_or_equal_to) : 0
          if(data.prerequisite_quantity_range.greater_than_or_equal_to <= 0)
            errors.push('Minimum item quantity must be greater than 0')
        }
        if(data._usage_limit){
          data.usage_limit = data.usage_limit ? parseInt(data.usage_limit) : 0
          if(data.usage_limit <= 0)
            errors.push('Usage limit must be greater than 0')
        }
        if(this.storeTypes['lazada'] && data.budget_type === 'LIMITED_BUDGET'){
          data.budget_value = data.budget_value ? parseInt(data.budget_value) : 0
          if(data.budget_value <= 0)
            errors.push('Total subsidy budget must be greater than 0')
        }
        this.form.data.validationErrors = errors
        return errors
      }
    },
    computed: {
      validationErrors: function () {
        return this.validatePromotion()
      }
    },
    mounted: function(){
      let starts_at = new Date()
      let ends_at = new Date()
      ends_at = new Date(ends_at.setMonth(ends_at.getMonth() + 1))
      this.form.data = {
        ...{
          title: this.form.code,
          value_type: 'percentage',
          value: '-100.0',
          target_type: 'shipping_line',
          target_selection: 'all',
          allocation_method: 'each',
          customer_selection: 'all',
          _prerequisite_type: 'none',
          prerequisite_subtotal_range: {
            greater_than_or_equal_to: null
          },
          prerequisite_quantity_range: {
            greater_than_or_equal_to: null
          },
          _prerequisite_shipping_price_range: false,
          prerequisite_shipping_price_range: {
            less_than_or_equal_to: null
          },
          entitled_product_ids: [],
          original_entitled_product_ids: [],
          _usage_limit: false,
          usage_limit: null,
          once_per_customer: false,
          starts_at: starts_at.toDateString(),
          ends_at: ends_at.toDateString(),
          _ends_at: true,
          apply: 'ENTIRE_SHOP',
          delivery_option: 'STANDARD',
          budget_type: 'UNLIMITED_BUDGET',
          budget_value: 0,
          region_value: [],
          region_type: 'ALL_REGIONS',
          period_type: 'SPECIAL_PERIOD',
          template_type: 'MANUALLY',
          validationErrors: []
        },
        ...this.form.data
      }
      this.form.data.original_entitled_product_ids = JSON.parse(JSON.stringify(this.form.data.entitled_product_ids))
    }
  }
</script>
